import { render, staticRenderFns } from "./editSystemTemp.vue?vue&type=template&id=4aa6552c&scoped=true"
import script from "./editSystemTemp.vue?vue&type=script&lang=js"
export * from "./editSystemTemp.vue?vue&type=script&lang=js"
import style0 from "./editSystemTemp.vue?vue&type=style&index=0&id=4aa6552c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa6552c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4aa6552c')) {
      api.createRecord('4aa6552c', component.options)
    } else {
      api.reload('4aa6552c', component.options)
    }
    module.hot.accept("./editSystemTemp.vue?vue&type=template&id=4aa6552c&scoped=true", function () {
      api.rerender('4aa6552c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/messageAlert/systemMessageTemplate/editSystemTemp.vue"
export default component.exports